export default {
  newPreset: 'Nová predvoľba',
};
